<template>
  <div>
    <div class="landscape">
      <div class="window"></div>
      <div class="screen">
        <div class="close space-1" @click="closePopup"></div>
        <div class="close space-2" @click="closePopup"></div>

        <div class="popup bsod container no-scrollbar">
          <div class="cross-close" @click="closePopup">X</div>
          <h1 class="neg title"><span class="bg">KAR-9000</span></h1>
          <div class="space-news no-scrollbar">
            <h2>NEWS FROM THE COSMOS:</h2>
            <ul>
              <div v-for="news in reversed_space_news" :key="news.id">
                <li>
                  <span class="date">{{ news.date }}</span
                  >: {{ news.text }}
                </li>
                <hr />
              </div>
            </ul>
          </div>
          <!--<div>
            <h2>MAP</h2>
            <Map></Map>
          </div>-->
          <div>
            <p>The crew evolves encrypted. To join our network:</p>
            <ul class="contact">
              <li>
                <a href="https://kizi404.bandcamp.com/releases" target="_blank"
                  >Bandcamp</a
                >
              </li>
              <li>
                <a
                  href="https://www.facebook.com/Kizi-404-111381530614708/"
                  target="_blank"
                  >Facebook</a
                >
              </li>
              <li>
                <a href="">Discogs</a>
              </li>
              <li>
                <a href="https://discord.gg/vWg4vmg" target="_blank">Discord</a>
              </li>
              <li>Contact: <a>kizi404@protonmail.com</a></li>
            </ul>
          </div>
          <nav class="nav">
            <a class="link" @click="closePopup()">CLOSE CONSOLE</a>
          </nav>
        </div>
      </div>
    </div>
    <div class="portrait">
      <NotOriented></NotOriented>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import NotOriented from "@/components/mobile/NotOriented";
import Map from "@/components/utilities/Map";
import { db } from "@/plugins/firebase";
export default {
  name: "MainConsole",
  data() {
    return {
      space_news: [],
      opened: true,
    };
  },
  computed: {
    reversed_space_news() {
      let arr = false;
      if (this.space_news.length > 0) {
        arr = this.space_news;
        arr = arr.reverse();
      }
      return arr;
    },
  },
  components: {
    NotOriented,
    Map,
  },
  methods: {
    closePopup() {
      this.opened = false;
      this.$emit("closePopup");
    },
    eventClose(e) {
      if (e.key === "Escape") {
        if (this.opened) this.closePopup();
      }
    },
  },
  mounted() {
    window.addEventListener("keyup", (e) => this.eventClose(e));
  },
  destroyed() {
    window.removeEventListener("keyup", (e) => this.eventClose(e));
  },
  firebase: {
    space_news: db.ref("space_news"),
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/landing-error.scss";

.cross-close {
  font-size: 4vw;
  z-index: 3;
  position: fixed;
  right: 28vw;
}

.close {
  position: absolute;
  height: 100vh;
}

hr {
  width: 66%;
}

.space-1 {
  left: 0;
  width: 20vw;
}

.space-2 {
  right: 0;
  width: 15vw;
}

.space-news {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  height: 30vh;
  font-size: 1.4rem;
  overflow-y: scroll;

  h2 {
    margin-bottom: 3px;
  }
  ul {
    padding: 10px;
    margin-top: 5px;
  }

  .date {
    background: $grey;
    color: $blue;
  }
}
li {
  list-style: none;
  text-align: initial;
}

.contact li {
  text-align: center;
  font-size: 2rem;
}

.contact {
  padding: 0;
}

.screen {
  position: absolute;
  background-image: url("../../assets/medias/images/oldscreen.png");
  height: 100vh;
  width: 100vw;
  background-size: 101vw 100vh;
  top: 0;
  left: 0;
  z-index: 2;
}

.window {
  position: absolute;
  min-width: 101vw;
  min-height: 101vh;
  top: 0;
  left: -5;
  z-index: 1;
  opacity: 0.5;
  background-color: black;
}

.popup {
  border-radius: 10px;
  padding: 20px;
  display: inline-block;
  position: absolute;
  left: 26vw;
  top: 23vh;
  max-width: 44vw;
  max-height: 45vh;
  text-align: center;
  background-color: $blue;
  opacity: 1;
  z-index: 2;
  overflow: scroll;
}

p {
  font-size: 1.5rem;
  color: $light-grey;
}

@media screen and (max-width: 750px) {
  p,
  .space-news {
    font-size: 6vh;
  }

  .contact li {
    font-size: 6vh;
  }
}
</style>
